import React, {Component} from 'react';
import {Card, Layout} from 'antd';
import SAInputLabel from '../../../components/common/input/SAInputLabel';
import SADatePicker from '../../../components/common/input/SADatePicker';
import FieldError from "../../../components/common/input/FieldError";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {isMobilityRental} from "../definition/business";
import {isOfficialInformationTouched} from "../definition/helper";

class PersonalInformationFragment extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.birthDateDisabledDate = this.birthDateDisabledDate.bind(this);
    this.deliveryDisabledDate = this.deliveryDisabledDate.bind(this);
    this.validityDisabledDate = this.validityDisabledDate.bind(this);
  }

  birthDateDisabledDate = d => !d || d.isAfter(this.major());
  deliveryDisabledDate = d => !d || d.isAfter(this.yesterday());
  validityDisabledDate = d => !d || d.isSameOrBefore(this.props.selectedDate);

  yesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  };

  major = () => {
    const bDate = new Date();
    bDate.setFullYear(bDate.getFullYear() - 18);
    return bDate;
  };

  renderInputLabel = (name, value, label, onChange, isMandatory, disabled, maxLenght) => (
    <li>
      <SAInputLabel
        name={name}
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        maxLength={maxLenght}
        error={isMandatory && !value ? { message: 'error.not.null' } : null}
      />
    </li>
  );

  renderAdvise = (formatMessage, label) => (
    <ul className="list" style={{ paddingBottom: 10 }}>
      <li>{formatMessage({ id: label })}</li>
    </ul>
  );

  renderAddressCard = (
    formatMessage,
    number,
    street,
    zipCode,
    city,
    country,
    onNumberChange,
    onStreetChange,
    onZipCodeChange,
    onCityChange,
    onCountryChange
  ) => (
    <Card
      title={<h2>{formatMessage({id: 'customer.journey.step.personalInformation.addressTitle'}).toUpperCase()}</h2>}
      bordered={false}
      style={{ width: '100%', marginBottom: 25 }}
    >
      <div className="wrap">
        <div className="content">
          <ul className="list">
            {this.renderInputLabel(
              'Vehicle',
              street,
              'customer.journey.personalInformation.address.street',
              onStreetChange,
              true
            )}
            {this.renderInputLabel(
              'number',
              number,
              'customer.journey.personalInformation.address.number',
              onNumberChange,
              true
            )}
            {this.renderInputLabel(
              'Zipcode',
              zipCode,
              'customer.journey.personalInformation.address.zipCode',
              onZipCodeChange,
              true
            )}
            {this.renderInputLabel(
              'City',
              city,
              'customer.journey.personalInformation.address.city',
              onCityChange,
              true
            )}
            {this.renderInputLabel(
              'Country',
              country,
              'customer.journey.personalInformation.address.country',
              onCountryChange,
              true
            )}
          </ul>
        </div>
      </div>
    </Card>
  );

  renderDatePicker = (formatMessage, name, label, value, onChange, onDisabledDate, isMandatory) => (
    <li>
      <div className="form-field" style={{ marginBottom: '.5rem' }}>
        <label htmlFor={`${name}Label`}>{formatMessage({ id: label })}</label>
        <SADatePicker
          name={name}
          value={value}
          onChange={onChange}
          onDisabledDate={onDisabledDate}
        />
        {isMandatory && !value && (
          <FieldError error={{ message: 'error.not.null' }} />
        )}
      </div>
    </li>
  );

  renderOfficialDocumentCard = (
    formatMessage,
    isOfficialInformationStarted,
    licenseId,
    licenseDeliveryDate,
    idNumber,
    birthDate,
    nationality,
    validity,
    selectedDate,
    onLicenseIdChange,
    onLicenseDeliveryDateChange,
    onIdCardNumberChange,
    onBirthDateChange,
    onNationalityChange,
    onValidityChange
  ) => (
    <Card
      title={<h2>{formatMessage({id: 'customer.journey.step.personalInformation.officialInformationTitle'})}</h2>}
      bordered={false}
      style={{ width: '100%', marginBottom: 25 }}
    >
      <div className="content">
        {this.renderAdvise(
          formatMessage,
          'customer.journey.step.personalInformation.officialInformationAdvise'
        )}
        <ul className="list">
          {this.renderInputLabel(
            'licenseId',
            licenseId,
            'customer.journey.personalInformation.officialDocument.licenseId',
            onLicenseIdChange,
            isOfficialInformationStarted
          )}
          {this.renderDatePicker(
            formatMessage,
            'deliveryDate',
            'customer.journey.personalInformation.officialDocument.deliveryDate',
            licenseDeliveryDate,
            onLicenseDeliveryDateChange,
            this.deliveryDisabledDate,
            isOfficialInformationStarted
          )}
          {this.renderInputLabel(
            'idNumber',
            idNumber,
            'customer.journey.personalInformation.officialDocument.idNumber',
            onIdCardNumberChange,
            isOfficialInformationStarted
          )}
          {this.renderDatePicker(
            formatMessage,
            'birthDate',
            'customer.journey.personalInformation.officialDocument.birthDate',
            birthDate,
            onBirthDateChange,
            this.birthDateDisabledDate,
            isOfficialInformationStarted
          )}
          {this.renderInputLabel(
            'nationality',
            nationality,
            'customer.journey.personalInformation.officialDocument.nationality',
            onNationalityChange,
            isOfficialInformationStarted
          )}
          {this.renderDatePicker(
            formatMessage,
            'validityDate',
            'customer.journey.personalInformation.officialDocument.validity',
            validity,
            onValidityChange,
            this.validityDisabledDate,
            isOfficialInformationStarted
          )}
        </ul>
      </div>
    </Card>
  );

  render() {
    const {
      intl:{formatMessage},
      // on change method
      onNumberChange,
      onStreetChange,
      onZipCodeChange,
      onCityChange,
      onCountryChange,
      onLicenseIdChange,
      onLicenseDeliveryDateChange,
      onIdCardNumberChange,
      onBirthDateChange,
      onNationalityChange,
      onValidityChange,
      mobility,
      // values
      number,
      street,
      zipCode,
      city,
      country,
      licenseId,
      licenseDeliveryDate,
      idCardNumber,
      birthDate,
      nationality,
      validity,
      selectedDate,
    } = this.props;
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const bDate = new Date();
    bDate.setFullYear(bDate.getFullYear() - 18);

    const {chosenMobility} = this.props.createAppointmentRequest;
    const showOfficialDocumentCard = chosenMobility && isMobilityRental(chosenMobility.mobilityOption, mobility.categoryMobility);
    const isOfficialInformationStarted = showOfficialDocumentCard && isOfficialInformationTouched({licenseId, licenseDeliveryDate, idCardNumber, birthDate, nationality, validity});

    return (
      <Layout style={{ backgroundColor: 'transparent' }}>
        {this.renderAddressCard(
          formatMessage,
          number,
          street,
          zipCode,
          city,
          country,
          onNumberChange,
          onStreetChange,
          onZipCodeChange,
          onCityChange,
          onCountryChange
        )}
        {showOfficialDocumentCard && this.renderOfficialDocumentCard(
          formatMessage,
          isOfficialInformationStarted,
          licenseId,
          licenseDeliveryDate,
          idCardNumber,
          birthDate,
          nationality,
          validity,
          selectedDate,
          onLicenseIdChange,
          onLicenseDeliveryDateChange,
          onIdCardNumberChange,
          onBirthDateChange,
          onNationalityChange,
          onValidityChange
        )}
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => ({
});

const mapStateToProps = state => ({
  createAppointmentRequest: state.createAppointmentRequest
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PersonalInformationFragment)
);



// WEBPACK FOOTER //
// ./src/public/journey1/fragments/PersonalInformationFragment.js